<template>
    <div class="popup" v-cloak v-if="isShow">
        <div class="content" id="appRecommend">
            <div class="app-recommend-close" @click="close()"></div>
            <div class="app-recommend-left">
                <div class="app-recommend-phone-img"></div>
            </div>
            <div class="app-recommend-body">
                <div class="app-recommend-title">{{$t('language.popup.appRecommendPopup.title')}}</div>
                <div class="app-recommend-tip" v-html="$t('language.popup.appRecommendPopup.tip')"></div>
                <div class="app-recommend-btns">
                    <div class="app-recommend-btn" @click="jumpToIosDownload()">
                        <div class="app-recommend-btn-img icon-apple"></div>
                        <div class="app-recommend-btn-tips">
                            <div class="app-recommend-btn-tip" v-if="getbtnType('ios')==1">{{$t('language.popup.appRecommendPopup.iosBtnTitle')}}</div>
                            <div class="app-recommend-btn-title">{{$t('language.popup.appRecommendPopup.iosBtnTip')}}</div>
                            <div class="app-recommend-btn-tip" v-if="getbtnType('ios')==2">{{$t('language.popup.appRecommendPopup.iosBtnTitle')}}</div>
                        </div>
                    </div>
                    <div class="app-recommend-btn" @click="jumpToAndroidDownload()">
                        <div class="app-recommend-btn-img icon-google"></div>
                        <div class="app-recommend-btn-tips">
                            <div class="app-recommend-btn-tip" v-if="getbtnType('android')==1">{{$t('language.popup.appRecommendPopup.androidBtnTitle')}}</div>
                            <div class="app-recommend-btn-title">{{$t('language.popup.appRecommendPopup.androidBtnTip')}}</div>
                            <div class="app-recommend-btn-tip" v-if="getbtnType('android')==2">{{$t('language.popup.appRecommendPopup.androidBtnTitle')}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isShow: false,
        }
    },
    methods: {
        close(){
            this.isShow = false;
            this.$parent.$refs.rightContBan.showFunnel();
        },
        jumpToIosDownload(){
            window.open("https://apps.apple.com/cn/app/fonetool/id1620281509","_blank");
        },
        jumpToAndroidDownload(){
            window.open("https://play.google.com/store/apps/details?id=com.multcloud.mobile","_blank");
        },
        //判断是哪一种按钮样式
        getbtnType(type) {
            let lang = this.$i18n.locale;
            if(lang == 'japanese'){
                return 2;
            }
            if(lang == 'chinese' && type == 'ios'){
                return 2;
            }
            if(lang == 'traditionalChinese' && (type == 'ios' || type == 'android')){
                return 2;
            }
            return 1;
        },
    }
}
</script>
<style scoped>
#appRecommend {
    width: 700Px;
    height: 480Px;
    border-radius: 16Px;
    background: url("../../../assets/images/appRecommend/bg.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    border: 0;
}

.app-recommend-left {
    padding: 40Px 10Px 41Px 53Px;
}

.app-recommend-left .app-recommend-phone-img{
    width: 217Px;
    height: 393Px;
    background: url("../../../assets/images/appRecommend/web_phone_mobile.png") no-repeat;
}

.app-recommend-body {
    text-align: right;
    padding-top: 64Px;
    padding-right: 40Px;
    font-family: Arial;
    user-select: none;
}

.app-recommend-title {
    font-size: 30Px;
    font-weight: bold;
    line-height: 36Px;
    color: #FFFFFF;
    text-shadow: 0Px 3Px 6Px rgba(0,0,0,0.16);
    opacity: 1;
}

.app-recommend-tip {
    font-size: 14Px;
    font-weight: 400;
    line-height: 21Px;
    color: #E6F7FF;
    opacity: 1;
    margin: 30Px 0 38Px;
}

.app-recommend-btn {
    background: #FFFFFF;
    opacity: 1;
    border-radius: 16Px;
    min-height: 64Px;
    min-width: 220Px;
    display: inline-flex;
    margin: 12Px 0;
    cursor: pointer;
}

.app-recommend-btn-img{
    width: 66Px;
}

.icon-apple {
    background: url("../../../assets/images/appRecommend/logo_Apple.svg") no-repeat;
    background-position: 24Px 10Px;
}

.icon-google {
    background: url("../../../assets/images/appRecommend/icon_google.svg") no-repeat;
    background-position: 27Px 10Px;
}

.app-recommend-btn-tips {
    font-family: Arial;
    color: #000000;
    display: flex;
    flex-direction: column;
    text-align: left;
    padding: 8Px 23Px 0 12Px;
}

.app-recommend-btn-tip {
    font-size: 12Px;
    font-weight: 400;
    line-height: 20Px;
    margin-top: 4Px;
}

.app-recommend-btn-title {
    font-size: 20Px;
    font-weight: bold;
    margin-top: 4Px;
}

.app-recommend-close {
    width: 54Px;
    height: 40Px;
    right: 0;
    position: absolute;
    background: url("../../../assets/images/appRecommend/icon_close.png") no-repeat;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/activity_popups/app_recommend_popup.vue